<template>
	<div class="full">
		<vxe-grid v-if="list_gridOptions" :loading="loading" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent" ref="agencysendwarehousetradedetail"></vxe-grid>
		<reportgoods-form :componentStore="componentStore" ref="agencysendwarehousetradereportgoodsForm" :row="currentRow" :detail="detail" />
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import reportgoodsForm from './form/reportgoods'
	export default {
		mixins: [listMixins],
		props: {
			componentStore: {
				default: () => {
					return null
				}
			},
			currentRow: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				loading: false,
				gridOptions: null,
				toolbarButton:[],
				detail:[]
			}
		},
		watch: {
			currentRow(e) {
				if (e) {
					this.currentRow = e
					this.loading = true
					this.$api.agencysendwarehouse.wlnlistTradeDetails({
						tradeUid:e.salercpt_uid,
						storageUid:e.storage_uid,					
						shopUid:e.sys_shop,
					}).then((res) => {
						this.$refs.agencysendwarehousetradedetail.reloadData(res)
						this.loading = false
					},()=>{
						this.loading = false
					})
				} else {
					this.tableData = []
				}
			}
		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(list_gridOptions){
				list_gridOptions.id = 'agencysendwarehouse'
				list_gridOptions.toolbarConfig.buttons = [{
					name: '发送代发信息',
					status: 'success',
					code: 'send'
				}]
				list_gridOptions.columns = [{
						type: 'checkbox',
						title: '#',
						width:50
					},{
						field: 'bar_code',
						title: '商品编码',
					}, {
						field: 'goods_name',
						title: '商品名称',
					}, {
						field: 'specValue',
						title: '规格',
					}, {
						field: 'price',
						title: '折后单价',
						formatter:({row})=>{
							return (row.tp_payment/row.tp_item_size).toFixed(4)
						}
					}, {
						field: 'tp_item_size',
						title: '数量',
					}, {
						field: 'tp_payment',
						title: '应收款',
					}, {
						field: 'sendnum',
						title: '消息发送次数',
				}]
				list_gridOptions.pagerConfig.enabled = false
				list_gridOptions.formConfig.enabled = false
				
			},
			send(){
				let data = this.$refs.agencysendwarehousetradedetail.getCheckboxRecords()
				if(data.length==0){
					this.$message.error('请选择数据')
					return
				}
				this.detail = data
				this.$nextTick(()=>{
					this.$refs.agencysendwarehousetradereportgoodsForm.modalShow()
				})
			}
		},
		components: {
			reportgoodsForm	
		}
	}
</script>